import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-encoding',
  templateUrl: './encoding.component.html',
  styleUrls: ['./encoding.component.css']
})
export class EncodingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
